import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';

@Injectable({
  providedIn: 'root',
})
export class VehicleSpecificationsService {
  constructor(private httpClient: HttpClient) {}

  getVehicleSpecificationsFields(language?: string): Observable<any> {
    const url = apiParameters.urlV2 + '/vehicle-specification-fields';

    let searchParams = new HttpParams();
    if (language && language !== '') {
      searchParams = searchParams.append('language', language);
    }
    const httpOptions = {
      params: searchParams,
    };

    return this.httpClient.get(url, httpOptions);
  }

  addVehicleSpecificationField(body: any): Observable<any> {
    const url = apiParameters.urlV2 + '/vehicle-specification-fields';
    return this.httpClient.post(url, body);
  }

  editVehicleSpecificationField(
    vehicleSpecificationFIeldId: string,
    body: any
  ): Observable<any> {
    const url =
      apiParameters.urlV2 +
      '/vehicle-specification-fields/' +
      vehicleSpecificationFIeldId;
    return this.httpClient.patch(url, body);
  }

  deleteVehicleSpecificationField(
    vehicleSpecificationFIeldId: string
  ): Observable<any> {
    const url =
      apiParameters.urlV2 +
      '/vehicle-specification-fields/' +
      vehicleSpecificationFIeldId;
    return this.httpClient.delete(url);
  }

  addVehicleSpecificationFieldTranslations(
    vehicleSpecificationFIeldId: string,
    body: any
  ): Observable<any> {
    const url =
      apiParameters.urlV2 +
      '/vehicle-specification-fields/' +
      vehicleSpecificationFIeldId +
      '/translations';
    return this.httpClient.post(url, body);
  }

  getEquipments(language?: string): Observable<any> {
    const url = apiParameters.urlV2 + '/equipment-items';

    let searchParams = new HttpParams();
    if (language && language !== '') {
      searchParams = searchParams.append('language', language);
    }
    const httpOptions = {
      params: searchParams,
    };

    return this.httpClient.get(url, httpOptions);
  }

  addEquipmentItem(body): Observable<any> {
    const url = apiParameters.urlV2 + '/equipment-items';
    return this.httpClient.post(url, body);
  }

  editEquipmentItem(equipmentItemId: string, body: any): Observable<any> {
    const url = apiParameters.urlV2 + '/equipment-items/' + equipmentItemId;
    return this.httpClient.patch(url, body);
  }

  deleteEquipmentItem(equipmentItemId: string): Observable<any> {
    const url = apiParameters.urlV2 + '/equipment-items/' + equipmentItemId;
    return this.httpClient.delete(url);
  }

  addEquipmentItemTranslations(
    equipmentItemId: string,
    body: any
  ): Observable<any> {
    const url =
      apiParameters.urlV2 +
      '/equipment-items/' +
      equipmentItemId +
      '/translations';
    return this.httpClient.post(url, body);
  }
}
